var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import HotKeyButton from './HotKeyButton';
import { useComponentLocale } from '../../../../../hooks/useComponentLocale';
import styles from './Hotkeys.module.scss';
var HotKeysSection = function (_a) {
    var title = _a.title, rows = _a.rows, handlePressKey = _a.handlePressKey, isDouble = _a.isDouble, disabledButtons = _a.disabledButtons, setIsDoubleKeys = _a.setIsDoubleKeys;
    var getLocale = useComponentLocale();
    var getLabel = function (key) {
        var label = '';
        switch (key) {
            case 'allin':
                label = 'All in';
                break;
            case 'check':
                label = 'Check / Call';
                break;
            case 'raise':
                label = 'Bet / Raise';
                break;
            case 'fold':
                label = 'Fold';
                break;
            default:
                label = getLocale({ component: 'hot_keys', section: key.toLowerCase() });
        }
        return label;
    };
    return (_jsxs("div", __assign({ className: styles.hotKeysSectionWrapper }, { children: [_jsx("h3", { children: title }), _jsxs("div", { children: [_jsx("span", __assign({ className: styles.staticLine }, { children: "Command" })), _jsx("span", __assign({ className: styles.staticLine }, { children: "Shortcut" }))] }), Object.entries(rows).map(function (_a) {
                var name = _a[0], value = _a[1];
                var label = getLabel(name);
                return (_jsxs("div", __assign({ className: styles.rowWrapper }, { children: [_jsx("span", { children: label }), _jsx(HotKeyButton, { keyName: name, value: value, onPressKey: handlePressKey, isDouble: isDouble, hotkeysGroup: title, isDisabled: disabledButtons.includes(name), setIsDoubleKeys: setIsDoubleKeys }, name), _jsx("div", { className: styles.rowBackground })] }), name));
            })] })));
};
export default HotKeysSection;
